/**
 * TrialBanner — shows the owner how many trial days are left, with a link to
 * choose a plan. Hidden for other statuses and for non-owners.
 */
import { Link } from "react-router-dom";
import { useCurrentSubscription } from "@/hooks/useSubscription";
import useAuthStore from "@/stores/authStore";

export default function TrialBanner() {
  const role = useAuthStore((s) => s.user?.role);
  const isOwner = role === "tenant_owner";
  const { data } = useCurrentSubscription({ enabled: isOwner });
  if (!isOwner || data?.status !== "trial") return null;

  const ends = data.trialEndsAt || data.endDate;
  const days = ends ? Math.ceil((new Date(ends).getTime() - Date.now()) / 864e5) : null;
  const ended = days !== null && days <= 0;

  return (
    <div
      role="status"
      className={`flex flex-wrap items-center justify-between gap-2 px-4 py-2 text-sm ${
        ended ? "bg-amber-50 text-amber-900" : "bg-[#4CAF50]/10 text-[#1B5E20]"
      }`}
    >
      <span>
        {ended
          ? "Your free trial has ended. Choose a plan to keep selling and recording stock."
          : `Free trial: ${days} day${days === 1 ? "" : "s"} left.`}
      </span>
      <Link to="/subscriptions" className="font-medium underline underline-offset-2">
        {ended ? "Choose a plan" : "Choose a plan now"}
      </Link>
    </div>
  );
}
